export const UPDATE_LOADING = (state, loading) => {
  state.isLoading = loading
}

export const UPDATE_DIRECTION = (state, direction) => {
  state.direction = direction
}



// WEBPACK FOOTER //
// ./src/store/mutations.js